import AutoFormCheckbox from './fields/checkbox';
import AutoFormContact from './fields/contact';
import AutoFormCoordinate from './fields/coordinate';
import AutoFormDate from './fields/date';
import AutoFormEnum from './fields/enum';
import AutoFormFile from './fields/file';
import AutoFormInput from './fields/input';
import AutoFormNumber from './fields/number';
import AutoFormPhoneNumbers from './fields/phone-numbers';
import AutoFormPositions from './fields/positions';
import AutoFormRadioGroup from './fields/radio-group';
import AutoFormStatus from './fields/status';
import AutoFormSwitch from './fields/switch';
import AutoFormTextarea from './fields/textarea';

export const INPUT_COMPONENTS = {
  checkbox: AutoFormCheckbox,
  coordinate: AutoFormCoordinate,
  contact: AutoFormContact,
  date: AutoFormDate,
  select: AutoFormEnum,
  radio: AutoFormRadioGroup,
  switch: AutoFormSwitch,
  textarea: AutoFormTextarea,
  number: AutoFormNumber,
  file: AutoFormFile,
  positions: AutoFormPositions,
  phoneNumbers: AutoFormPhoneNumbers,
  status: AutoFormStatus,
  fallback: AutoFormInput,
};

/**
 * Define handlers for specific Zod types.
 * You can expand this object to support more types.
 */
export const DEFAULT_ZOD_HANDLERS: {
  [key: string]: keyof typeof INPUT_COMPONENTS;
} = {
  boolean: 'checkbox',
  coordinate: 'coordinate',
  contact: 'contact',
  date: 'date',
  enum: 'select',
  number: 'number',
  positions: 'positions',
  phoneNumbers: 'phoneNumbers',
  status: 'status',
};
